import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { PrimaryButton } from '../common/Buttons';
import PersonBg from '../images/cta-person.png';

import './style.css';

function CallToActionSection() {
  return (
    <section id="call-to-action" className="cta-section">
      <Container>
        <div className="cta-bg">
          <img
            src={PersonBg}
            alt="Person CTA"
            className="cta-person d-none d-md-block"
          />

          <Row className="align-items-center">
            <Col md={{ size: 7, offset: 5 }} xs="12">
              <div className="px-md-4 text-center text-md-start">
                <h2 className="fw-bold mb-3">
                  Ready to launch your digital growth?
                </h2>
                <p className="lead mb-4">
                  Get a free consultation and see how we can transform your business online.
                </p>
                <PrimaryButton href="/contact">
                  📩 Request Free Consultation
                </PrimaryButton>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default CallToActionSection;
